import styled, { css } from 'styled-components';

import { CardComponentProps } from './Card';

import { Typography } from '@speeki/global-ui-components';

import { breakpoints } from '@shared/constants';

export const CardWrapper = styled.div<{
    alignContent?: CardComponentProps['alignContent'];
}>(
    ({ alignContent, theme: { boxShadow, palette, radius } }) => css`
        align-content: ${alignContent ? alignContent : 'start'};
        background: ${palette.neutral.white};
        border-radius: ${radius[8]}px;
        box-shadow: ${boxShadow.small};
        display: grid;
        padding: 48px 48px 56px;
        width: 100%;

        @media (max-width: ${breakpoints.md}px) {
            padding: 48px 24px 56px;
        }

        @media (max-width: ${breakpoints.sm}px) {
            border-radius: 0;
            box-shadow: none;
            padding: 0;
        }
    `,
);

export const CardTitle = styled(Typography.TextH1_36_52)`
    margin-bottom: 24px;
`;

export const CardTitleSecondary = styled(Typography.TextH2_28_44)`
    margin-bottom: 8px;
`;

export const CardTitleTertiary = styled(Typography.TextH3_24_34)`
    margin-bottom: 8px;
`;

export const CardDescription = styled(Typography.TextBody_16_24)`
    margin-bottom: 24px;
`;

export const CardListItem = styled(Typography.TextBullet_16_22)`
    align-items: center;
    display: flex;
`;

export const CardList = styled.ul`
    display: grid;
    grid-row-gap: 8px;
    list-style-type: none;
    margin: 0;
    padding-left: 0;

    @media (max-width: ${breakpoints.md}px) {
        flex-wrap: wrap;
    }
`;
